import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import PaymentService from '../../services/paymentServices';
import StudentService from '../../services/studentServices';
import { clearAuth } from 'store/auth';

export const getList = createAsyncThunk('payment/list', async ({ page, perPage, sort, orderBy, search, status }, thunkAPI) => {
  try {
    const response = await PaymentService.getList(page, perPage, sort, orderBy, search, status);

    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk(
  'payment/getListArchive',
  async ({ page, perPage, sort, orderBy, search, status }, thunkAPI) => {
    try {
      const response = await PaymentService.getListArchive(page, perPage, sort, orderBy, search, status);

      return response.data;
    } catch (error) {
      if (error.response.status === 401) {
        thunkAPI.dispatch(clearAuth());
      }
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
      thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createData = createAsyncThunk('payment/create', async (data, thunkAPI) => {
  try {
    const response = await PaymentService.create(data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const readData = createAsyncThunk('payment/read', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.read(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updateData = createAsyncThunk('payment/update', async ({ id, data }, thunkAPI) => {
  try {
    const response = await PaymentService.update(id, data);
    // Show success message if notes is being updated
    if (data.notes !== undefined) {
      thunkAPI.dispatch(setMessage({ message: 'Notes berhasil disimpan', type: 'success' }));
    }
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const deleteData = createAsyncThunk('payment/delete', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.del(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changePaymentStatus = createAsyncThunk('payment/changePaymentStatus', async (data, thunkAPI) => {
  try {
    const response = await PaymentService.changePaymentStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const changeStatus = createAsyncThunk('payment/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await PaymentService.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const addDiscount = createAsyncThunk('payment/addDiscount', async (data, thunkAPI) => {
  try {
    const response = await PaymentService.addDiscount(data);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteDiscount = createAsyncThunk('payment/deleteDiscount', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.deleteDiscount(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const addCharges = createAsyncThunk('payment/addCharges', async (data, thunkAPI) => {
  try {
    const response = await PaymentService.addCharges(data);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteCharges = createAsyncThunk('payment/deleteCharges', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.deleteCharges(id);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const addFile = createAsyncThunk('payment/addFile', async ({ id, data }, thunkAPI) => {
  try {
    const response = await PaymentService.addFile(id, data);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    console.log(error);
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteFile = createAsyncThunk('payment/deleteFile', async ({ id, fileID }, thunkAPI) => {
  try {
    const response = await PaymentService.deleteFile(id, fileID);
    const message = (response && response.data && response.data.message) || response.message || response.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getStudentPayment = createAsyncThunk('payment/student', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await StudentService.getPayment(id, page, perPage, sort, orderBy);
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const sendWhatsAppNotification = createAsyncThunk('payment/sendWhatsApp', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.sendWhatsAppNotification(id);
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const updatePaymentPeriods = createAsyncThunk('payment/updatePaymentPeriods', async ({ id, data }, thunkAPI) => {
  try {
    const response = await PaymentService.updatePaymentPeriods(id, data);
    thunkAPI.dispatch(setMessage({ message: 'Periode pembayaran berhasil disimpan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const ajukanPayment = createAsyncThunk('payment/ajukanPayment', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.ajukanPayment(id);
    thunkAPI.dispatch(setMessage({ message: 'Pembayaran berhasil diajukan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const batalAjukanPayment = createAsyncThunk('payment/batalAjukanPayment', async (id, thunkAPI) => {
  try {
    const response = await PaymentService.batalAjukanPayment(id);
    thunkAPI.dispatch(setMessage({ message: 'Pengajuan pembayaran berhasil dibatalkan', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

const initialState = { isLoading: false, list: [], data: [], error: [] };

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getStudentPayment.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getStudentPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getStudentPayment.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updateData.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.data = action.payload;
        }
      }),
      builder.addCase(updateData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changePaymentStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changePaymentStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(changePaymentStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addDiscount.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addDiscount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addDiscount.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteDiscount.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteDiscount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(deleteDiscount.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addCharges.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addCharges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addCharges.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteCharges.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteCharges.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(deleteCharges.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(addFile.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(addFile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(addFile.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteFile.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteFile.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(deleteFile.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sendWhatsAppNotification.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(sendWhatsAppNotification.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sendWhatsAppNotification.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updatePaymentPeriods.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(updatePaymentPeriods.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(updatePaymentPeriods.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(ajukanPayment.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(ajukanPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(ajukanPayment.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(batalAjukanPayment.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(batalAjukanPayment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(batalAjukanPayment.rejected, (state) => {
        state.isLoading = false;
      });
  }
});

const { reducer } = paymentSlice;
export default reducer;
